import { React, useState, useRef, useEffect } from "react";
import ClientLayout from "../components/layout/ClientLayout";
export default function RulesHRGR({ onClose }) {
  const [showModal, setShowModal] = useState(false);
  const closeButton = () => {
    setShowModal(false);
  };

  return (
    <>
      <style>
        {`
              .modal-content-style {
                  max-width: 1000px !important;
                  width: 100% !important;
                  max-height: 95vh !important;
                  background-color: #ffff;
                  color: #000
              }
              `}
      </style>

      <div
        class="modal fade show"
        id="modalMarketRules"
        tabindex="-1"
        role="dialog"
        aria-labelledby="modalMarketRules"
        style={{ display: "block", paddingLeft: "0px" }}
      >
        <div
          class="modal-dialog modal-lg"
          role="document"
          style={{ top: "13%" }}
        >
          <div class="modal-content modal-content-style">
            <div
              class="modal-header"
              style={{
                borderBottom: "0px",
                padding: "10px",
                background: "white"
              }}
            >
              <div class="modal-title" id="exampleModalLabel">
                Market Rules
              </div>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
                style={{
                  color: "white",
                  margin: "-1.1rem -0.7rem -0.9rem auto"
                }}
              >
                <span
                  aria-hidden="true"
                  style={{ color: "#000", opacity: "0.8" }}
                  onClick={onClose}
                >
                  ×
                </span>
              </button>
            </div>
            <div
              id="market-rules-text"
              class="modal-body"
              style={{ textAlign: "center", padding: "8px 0px 0px 0px" }}
            >
              <div class="container-fluid">
                <div data-typeid="" class="row rules-container">
                  <div class="col nopading rules-description">
                    <div>
                      <p style={{ textAlign: "left", fontWeight: "bold" }}>
                        MARKET INFORMATION
                      </p>
                      <p style={{ textAlign: "left" }}>
                        This market information applies to Exchange Singles bets
                        only. Please see our Rules & Regs for further
                        information, multiples and all other sections.
                      </p>
                      <p style={{ textAlign: "left" }}>
                        Who will win this race? Betfair Non-Runner Rule applies.
                        This market will turn IN PLAY at the off with unmatched
                        bets (with the exception of bets for which the "keep"
                        option has been selected) cancelled once the Betfair SP
                        reconciliation process has been completed. Betting will
                        be suspended at the end of the race. Should there be a
                        very close finish, a photo finish declared, a Stewards
                        Enquiry or an Objection called the market may be
                        re-opened with unmatched bets (again with the exception
                        of bets for which the "keep" option has been selected)
                        cancelled. The market will then be suspended when this
                        result is announced. This market will initially be
                        settled on a First Past the Post basis. However we will
                        re-settle all bets should the official result at the
                        time of the "weigh-in" announcement differ from any
                        initial settlement. BETS ARE PLACED ON A NAMED HORSE.
                        Dead Heat rules apply.
                      </p>
                      <p style={{ textAlign: "left" }}>
                        Customers should be aware that:
                      </p>
                      <p style={{ textAlign: "left", fontWeight: "bold" }}>
                        <li>
                          1. transmissions described as "live" by some
                          broadcasters may actually be delayed;
                        </li>
                      </p>
                      <p style={{ textAlign: "left", fontWeight: "bold" }}>
                        <li>
                          2.the extent of any such delay may vary, depending on
                          the set-up through which they are receiving pictures
                          or data; and
                        </li>
                      </p>
                      <p style={{ textAlign: "left", fontWeight: "bold" }}>
                        <li>
                          3.information (such as jockey silks, saddlecloth
                          numbers etc) is provided "as is" and is for guidance
                          only. Betfair does not guarantee the accuracy of this
                          information and use of it to place bets is entirely at
                          your own risk.
                        </li>
                      </p>
                      <p></p>
                    </div>
                  </div>
                </div>
                <div style={{ height: "9px" }}></div>
                <div class="modal-footer" style={{ padding: "0px 0px" }}></div>
                <div>&nbsp;</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
